export interface CarBrand {
    id: string;
    createdAt: string;
    updatedAt: string | null;
    deletedAt: string | null;
    name: string;
}

export const defaultCarBrand: CarBrand = {
    id: '',
    createdAt: '',
    updatedAt: null,
    deletedAt: null,
    name: ''
};